export const calculateColumnCount = (width: number, columnWidth: number, gutterSize: number) =>
    Math.floor(width / (columnWidth + gutterSize));
